import script from "./MisReservasPago.vue?vue&type=script&setup=true&lang=js"
export * from "./MisReservasPago.vue?vue&type=script&setup=true&lang=js"

import "./MisReservasPago.vue?vue&type=style&index=0&id=5b18b90d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b18b90d"]])

export default __exports__